import * as yup from 'yup';

export const validationSchema = yup.object({
    coupon: yup
    .string()
    .required("Coupon code is required")
    // .matches( "NSWECOME","Only numbers are allowed")
})